import PropTypes from 'prop-types';
import React from 'react';
import { Col, Row, Card } from 'react-bootstrap';

const PayrollWidget = ({
  title,
  amount,
  icon,
  link = '/',
  iconBackground = 'green'
}) => {
  const iconClass = icon
    ? 'fas ' + icon + ' text-white'
    : 'fas fa-shield-alt text-white';

  return (
    <>
      <Card>
        <Card.Body>
          <Row>
            <Col lg={3}>
              <div
                style={{
                  backgroundColor: iconBackground,
                  padding: '10px',
                  borderRadius: '6px',
                  width: '40px',
                  height: '40px',
                  display: 'flex', // ← add this
                  alignItems: 'center', // ← add this
                  justifyContent: 'center' // ← add this
                }}
                className="flex items-center justify-center"
              >
                <i className={iconClass}></i>
              </div>
            </Col>
            <Col>
              <div className="ml-5 w-0 flex-1">
                <dl>
                  <dt className="text-sm font-medium text-gray-500 truncate">
                    {title}
                  </dt>
                  <dd>
                    <div className="text-base font-medium text-gray-900">
                      {amount}
                    </div>
                  </dd>
                </dl>
              </div>
            </Col>
          </Row>
        </Card.Body>
        <Card.Footer
          className="bg-gray-100 text-gray-500"
          style={{ backgroundColor: '#F9FAFB' }}
        >
          {' '}
          <a
            href={link}
            data-readdy="true"
            className="font-sm text-blue-600 hover:text-blue-500 cursor-pointer"
          >
            View details
          </a>
        </Card.Footer>
      </Card>
    </>
  );
};

PayrollWidget.propTypes = {
  amount: PropTypes.any,
  icon: PropTypes.any,
  iconBackground: PropTypes.string,
  link: PropTypes.string,
  title: PropTypes.any
};

export default PayrollWidget;
